import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet-async'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import styles from './_couponPage.css'
import premiumStyles from './_premium.css'
import Button from 'components/util/Button'
import { applyCoupon } from 'services/premium/actions'
import * as premium from 'services/premium/selectors'
import * as site from 'services/site/selectors'
import * as user from 'services/user/selectors'
import * as auth from 'services/auth/selectors'
import { selectLocation } from 'services/routing/selectors'
import { fetchGeoIp } from 'services/auth/actions'
import Loader from 'components/util/Loader'
import Modal from 'components/util/Modal'

const mapStateToProps = (state) => ({
  siteName: site.selectSiteName(state),
  userId: user.selectUserId(state),
  error: premium.selectError(state),
  errorCode: premium.selectErrorCode(state),
  error_description: premium.selectErrorDescription(state),
  submitting: premium.selectSubmitting(state),
  attemptedCoupon: premium.selectAttemptedCoupon(state),
  countryCode: auth.selectAuthCountry(state),
  location: selectLocation(state),
})

const mapDispatchToActions = {
  applyCoupon,
  push,
  fetchGeoIp,
}

export class CouponPage extends Component {

  static propTypes = {
    applyCoupon: PropTypes.func,
    siteName: PropTypes.string,
    userId: PropTypes.number,
    error_description: PropTypes.string,
    errorCode: PropTypes.string,
    error: PropTypes.bool,
    push: PropTypes.func,
    submitting: PropTypes.bool,
    location: PropTypes.object,
    intl: PropTypes.object,
    attemptedCoupon: PropTypes.string,
    fetchGeoIp: PropTypes.func,
    countryCode: PropTypes.string,
  }

  state = {
    coupon: null,
  }

  componentWillMount () {
    const { location } = this.props
    const { search, query } = location
    const { code, discount } = query

    if (code || discount) {
      this.props.push(`/premium/checkout/${search}`)
    }
    this.props.fetchGeoIp()
  }

  handleCouponChange = ({ target: { value }}) => {
    this.setState({ coupon: value })
  }

  handleApplyCoupon = (evt) => {
    evt.preventDefault()
    const { userId, countryCode } = this.props
    const { coupon } = this.state
    if (coupon) {
      this.props.applyCoupon({ couponCode: coupon, userId, countryCode })
        .then(this.handleCouponSuccess)
    }
  }

  handleCouponSuccess = () => {
    this.props.push('/premium/checkout')
  }

  /**
   * Convenience method because coupon related error messages
   * need to contain dynamic information
   */
  getCouponError = () => {
    const { attemptedCoupon, userId, errorCode, error_description: fallback } = this.props

    const errorMessages = {

      'coupon_validation/4': (
        <FormattedMessage
          id='premium.coupon.error.invalid'
          defaultMessage='Sorry, the coupon "{coupon}" is invalid.'
          values={{ coupon: attemptedCoupon }}
        />
      ),

      'coupon_validation/6': (
        <FormattedMessage
          id='premium.coupon.error.already_used'
          defaultMessage='Sorry, the coupon {coupon} has already been granted for this user.'
          values={{ coupon: attemptedCoupon, userId: userId }}
        />
      ),

      'coupon_validation/8': (
        <FormattedMessage
          id='premium.coupon.error.first_time_premium_only'
          defaultMessage='Sorry, the coupon {coupon} is only valid for a first time MVP user.'
          values={{ coupon: attemptedCoupon }}
        />
      ),

    }

    return errorMessages[errorCode] || fallback
  }

  render () {
    const { error, siteName, submitting, intl } = this.props

    return (
      <div className={styles.container}>
        <Helmet title={intl.formatMessage({
          id: 'premium.coupon.title',
          defaultMessage: 'Redeem Coupon',
        })} />

        <Modal isOpen={submitting}>
          <div className={premiumStyles.loadingModal}>
            <div>
              <Loader height={50} width={50} />
            </div>
            <h3 className={premiumStyles.loadingTitle}>
              <FormattedMessage
                id='premium.coupon.processing'
                defaultMessage='Processing coupon'
              />
            </h3>
          </div>
        </Modal>

        <h2 className={styles.title}>
          <FormattedMessage
            id='premium.coupon.headline'
            defaultMessage='Welcome to {siteName}'
            values={{ siteName }}
          />
        </h2>

        <h3 className={styles.subhead}>
          <FormattedMessage
            id='premium.coupon.subhead'
            defaultMessage='Enter Promo Code Below'
          />
        </h3>

        <form
          className={styles.form}
          onSubmit={this.handleApplyCoupon}
        >
          <label htmlFor='code'>
            <input
              type='text'
              placeholder='New promo code'
              className={styles.input}
              onChange={this.handleCouponChange}
            />
          </label>
          <Button type='secondary' el='button'>
            <FormattedMessage
              id='premium.coupon.apply'
              defaultMessage='Apply'
            />
          </Button>
        </form>

        {/* errors */}
        {error ?
          <div className={styles.errorMessage}>
            {this.getCouponError()}
          </div>
        : null}

        <p>
          <a href='https://support.mapmyfitness.com/hc/en-us/categories/200003394-MVP-Membership' className={styles.link}>
            <FormattedMessage
              id='premium.coupon.not_working'
              defaultMessage='Promo code not working?'
            />
          </a>
        </p>
      </div>
    )
  }

}

export const Page = injectIntl(CouponPage)
export default connect(mapStateToProps, mapDispatchToActions)(Page)
